import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "flex flex-center column fit" }, {
        default: _withCtx(() => [
            (_ctx.isPasswordReset)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-h6 q-mb-md" }, " パスワード変更が必要です。以下のリンクから変更してください。 ", -1)),
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.openPasswordChange && _ctx.openPasswordChange(...args)), ["prevent"]))
                    }, " パスワード変更はこちら ")
                ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }));
}
